import { __makeTemplateObject } from "tslib";
import styled, { css } from 'styled-components';
import Paper from '../Paper';
import { getColorFromTheme } from '../utils/colors';
var positionStyle = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: ", ";\n  top: 0;\n  left: auto;\n  right: 0;\n"], ["\n  position: ", ";\n  top: 0;\n  left: auto;\n  right: 0;\n"])), function (props) { return props.position; });
var staticPositionStyle = css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: static;\n"], ["\n  position: static;\n"])));
var getBgColor = function (props) {
    if (props.color === 'default') {
        return props.theme.palette.background.appBar;
    }
    return getColorFromTheme(props);
};
var AppBar = styled(Paper).attrs({
    square: true,
    as: 'header',
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  flex-shrink: 0;\n  flex-direction: column;\n  width: 100%;\n  box-sizing: border-box;\n  padding: 0;\n  z-index: ", ";\n  ", ";\n  background-color: ", ";\n  color: ", ";\n"], ["\n  display: flex;\n  flex-shrink: 0;\n  flex-direction: column;\n  width: 100%;\n  box-sizing: border-box;\n  padding: 0;\n  z-index: ", ";\n  ",
    ";\n  background-color: ", ";\n  color: ", ";\n"])), function (props) { return props.theme.zIndex.appBar; }, function (props) {
    return props.position === 'static' ? staticPositionStyle : positionStyle;
}, getBgColor, function (props) { return props.theme.palette.getContrastText(getBgColor(props)); });
AppBar.defaultProps = {
    color: 'primary',
    position: 'fixed',
};
export default AppBar;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=AppBar.js.map